export default class LookupValue {
  id: number;
  description: string;
  recertificationInterval;
  string;
  subLookup: Record<string, LookupValue[]>;
  constructor(
    id: number = 0,
    description: string = "",
    recertificationInterval: string = ""
  ) {
    this.id = id;
    this.description = description;
    this.recertificationInterval = recertificationInterval;
  }
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/lookupValue.ts